import {AxiosError} from 'axios';

const getErrorFromResponse = (error: AxiosError): string => {
    return (error.response.data && error.response.data.errorMessage) || '';
};

export default getErrorFromResponse;
